export const HOME_CONTAINER_WIDTH = 1135
export const HOME_DESKTOP_HEADER_HEIGHT = 88

export const FREEDOM_TOOL_EMAIL = 'info@freedomtool.org'
